import { atom } from "jotai";
import { emitEventOnExecuteZslSetter } from "../events";
import { templateSlugAtom } from "./templateSlugAtom";
import { executeZslAndSaveSetter } from "./executeZslAndSaveSetter";

// Using any for CopilotChatService since its type is not exported from ai-toolkit/client
export type CopilotChatService = any;

export const handleUseTemplateSetter = atom(
  null,
  async (get, set, copilot: any, conversationId: string) => {
    const templateSlug = get(templateSlugAtom);

    if (templateSlug) {
      set(emitEventOnExecuteZslSetter, templateSlug);
    }

    await set(executeZslAndSaveSetter, { copilot, conversationId });
  },
);

handleUseTemplateSetter.debugLabel = "handleUseTemplateSetter";
